import { render, staticRenderFns } from "./deliverability.vue?vue&type=template&id=6c287808&scoped=true"
import script from "./deliverability.vue?vue&type=script&lang=js"
export * from "./deliverability.vue?vue&type=script&lang=js"
import style0 from "./deliverability.vue?vue&type=style&index=0&id=6c287808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c287808",
  null
  
)

export default component.exports